import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import UserNavBar from "../../components/UserNavBar";
import { redirect, useNavigate } from "react-router-dom";
export function loader({ req }) {
  console.log(sessionStorage.getItem("jwtToken") === null);
  if (sessionStorage.getItem("jwtToken") === null) {
    throw redirect("/?message=PleaseLogin");
  }
  return null;
}
export default function Gallery() {
  const navigate = useNavigate();
  return (
    <div>
      <UserNavBar />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="grid gap-4">
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766037746/harshit.jpg"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038010/post0.png"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038040/demo.jpg"
              alt="Gallery image"
            />
          </div>
        </div>
        <div className="grid gap-4">
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766037766/user3.jpg"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038011/post1.jpg"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038012/post2.jpg"
              alt="Gallery image"
            />
          </div>
        </div>
        <div className="grid gap-4">
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038022/post3.jpg"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038024/post4.jpg"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766038027/post5.png"
              alt="Gallery image"
            />
          </div>
        </div>
        <div className="grid gap-4">
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766037764/user1.jpg"
              alt="Gallery image"
            />
          </div>
          <div>
            <img
              className="h-auto max-w-full rounded-lg"
              src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766037765/user2.jpg"
              alt="Gallery image"
            />
          </div>
          {/* <div>
              <img
                className="h-auto max-w-full rounded-lg"
                src="https://res.cloudinary.com/dv1fwnib8/image/upload/v1766037766/user3.jpg"
                alt=""
              />
            </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}
